import React, { useState, useEffect } from 'react';
import '../css/LessonControlPanel.scss'; // We'll add some basic styling

/**
 * A control panel component for filtering a list of lessons.
 *
 * @param {object[]} lessons - The full array of lesson objects.
 * @param {function} onFilterChange - A callback function that is called
 * whenever the filter or search criteria change. It passes an object
 * with the current filter state.
 */
const LessonControlPanel = ({ lessons, onFilterChange }) => {
  const [filters, setFilters] = useState({
    searchTerm: '',
    category: 'All',
    difficulty: 'All',
  });

  // Dynamically generate the list of unique categories and difficulties from the data
  // This means if you add a new category to your lessons.js, it appears automatically!
  const categories = ['All', ...new Set(lessons.map(lesson => lesson.category))];
  const difficulties = ['All', ...new Set(lessons.map(lesson => lesson.difficulty))];

  // A single handler function to update our filters state
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  // This is the magic part: a useEffect hook that calls the onFilterChange
  // callback whenever the 'filters' state changes. This "lifts the state up"
  // to the parent component.
  useEffect(() => {
    onFilterChange(filters);
  }, [filters, onFilterChange]);


  return (
    <div className="lesson-control-panel">
      <div className="search-bar">
        <input
          type="text"
          name="searchTerm"
          placeholder="Search lessons..."
          value={filters.searchTerm}
          onChange={handleInputChange}
          className="search-input"
        />
      </div>
      <div className="filter-groups">
        <div className="filter-group">
          <label htmlFor="category-select">Category:</label>
          <select
            id="category-select"
            name="category"
            value={filters.category}
            onChange={handleInputChange}
            className="filter-select"
          >
            {categories.map(category => (
              <option key={category} value={category}>{category}</option>
            ))}
          </select>
        </div>
        <div className="filter-group">
          <label htmlFor="difficulty-select">Difficulty:</label>
          <select
            id="difficulty-select"
            name="difficulty"
            value={filters.difficulty}
            onChange={handleInputChange}
            className="filter-select"
          >
            {difficulties.map(difficulty => (
              <option key={difficulty} value={difficulty}>{difficulty}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default LessonControlPanel;